import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchOrdersRequest } from "./../redux/actions/orderActions";
import { format, getOverlappingDaysInIntervals } from 'date-fns';
import Modal from "./../components/Modal";

const Myorders = () => {
  const dispatch = useDispatch();
  const { orders, currentPage, totalPages, loading, error } = useSelector(
    (state) => state.orders
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentUser , setcurrentUser] = useState("")
  const [currentUserEmail, setcurrentUserEmail]= useState("")
  const [selectedOrder, setSelectedOrder] = useState(null)
  
  useEffect(() => {
    dispatch(fetchOrdersRequest(currentPage));
    if(orders && orders.length>0){
      setcurrentUser(' ' + orders[0].first_name + ' ' + orders[0].last_name  )
      setcurrentUserEmail(' ' +orders[0].email)
    }
    
  }, [dispatch, currentPage]);

  const handlePageChange = (page) => {
    dispatch(fetchOrdersRequest(page));
  };
  const handleShowDetails =(order)=>{
      setSelectedOrder(order)
      setIsModalOpen(true);
  }
  const closeModal = () => {
    setIsModalOpen(false); // Close the modal
    dispatch(fetchOrdersRequest(1));
  };

  return (
    <div className="p-4">
      <Modal isOpen={isModalOpen} closeModal={closeModal} heading="Order Details" data={selectedOrder} dataMode="orderdetails"  />
      {loading && <p>loading...</p>}
      {error && <p className="text-red-500">{error}</p>}
      {!loading && !error && (
        <>
        {orders && (
          <div className="flex items-center justify-between mb-2">
          <div className="flex items-start">
                <strong>Name: </strong>  <span className="mx-2">{currentUser}</span>
          </div>
          
          <div className="flex  items-end">
               <strong  >Email: </strong> <span className="mx-2"> {currentUserEmail} </span>
          </div>
  
          </div>
        )}
          <table className="table-auto w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-200 ">
              <th className="border border-gray-300 px-2 py-1 text-xs">Order Date</th>
                <th className="border border-gray-300 px-2 py-1 text-xs">Order Number</th>
                {/* <th className="border border-gray-300 px-2 py-1 text-xs">Name</th> */}
                {/* <th className="border border-gray-300 px-2 py-1 text-xs">Email</th> */}
                <th className="border border-gray-300 px-2 py-1 text-xs">Amount</th>
                <th className="border border-gray-300 px-2 py-1 text-xs">Status</th>
                <th className="border border-gray-300 px-2 py-1 text-xs"></th>
              </tr>
            </thead>
            <tbody>
              {orders?.map((order) => (
                <tr key={order.order_number} className="hover:bg-gray-100 text-xs">
                  <td className="border border-gray-300 px-2 py-1">
                    {format(order.created_at,'dd/MM/yyyy')}
                  </td>
                  <td className="border border-gray-300 px-2 py-1">
                    {order.order_number.replace('#','')}
                  </td>
                  {/* <td className="border border-gray-300 px-2 py-1">
                    {order.first_name} {order.last_name}
                  </td> */}
                  {/* <td className="border border-gray-300 px-2 py-1">
                   { order.email}
                  </td> */}
                  <td className="border border-gray-300 px-1 py-1">
                  <strong>PKR  {Math.trunc(order.total)}/-</strong>
                  </td>
                  <td className="border border-gray-300 px-2 py-1">
                   { order.status.status}
                  </td>
                  <td className="border border-gray-300 px-1 py-1">
                    {/* <i  title="Track your order" onClick={() => alert(`Track order: ${order.order_number}`)} className="fa-solid fa-up-down-left-right"></i>
                    <span style={{color:'purple'}} > | </span> */}
                    <i  title="Show Details"  onClick={() => handleShowDetails(order)} className="fa-solid fa-list cursor-pointer"></i>
                      
                    {/* <span style={{color:'purple'}}> | </span>
                    <i style={{color:'red'}}  title="Cancel Order" onClick={() => alert(`Track order: ${order.order_number}`)} className="fa-solid fa-cancel"></i> */}
                  </td>
                  
                </tr>
              ))}
            </tbody>
          </table>
          <div className="flex justify-center items-center mt-4">
            {/* <button
              className="px-3 py-1 mx-1 bg-gray-300 rounded hover:bg-gray-400"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              &lt;
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                className={`px-3 py-1 mx-1 rounded text-sx ${
                  page === currentPage
                    ? "bg-blue-500 text-white"
                    : "bg-gray-300 hover:bg-gray-400"
                }`}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </button>
            ))}
            <button
              className="px-3 py-1 mx-1 bg-gray-300 rounded hover:bg-gray-400"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              &gt;
            </button> */}
            {totalPages > 1 && (
                <div className="flex justify-center items-center space-x-2">
                  {/* Previous button */}
                  {currentPage > 1 && (
                    <button
                      className="px-3 py-1 mx-1 rounded bg-gray-300 hover:bg-gray-400"
                      onClick={() => handlePageChange(currentPage - 1)}
                    >
                      Previous
                    </button>
                  )}

                  {/* Pagination buttons */}
                  {(() => {
                    const pages = [];
                    const startPage = Math.max(1, currentPage - 2);
                    const endPage = Math.min(totalPages, currentPage + 2);

                    for (let i = startPage; i <= endPage; i++) {
                      pages.push(
                        <button
                          key={i}
                          className={`px-3 py-1 mx-1 rounded ${
                            i === currentPage
                              ? "bg-blue-500 text-white"
                              : "bg-gray-300 hover:bg-gray-400"
                          }`}
                          onClick={() => handlePageChange(i)}
                        >
                          {i}
                        </button>
                      );
                    }

                    return pages;
                  })()}

                  {/* Next button */}
                  {currentPage < totalPages && (
                    <button
                      className="px-3 py-1 mx-1 rounded bg-gray-300 hover:bg-gray-400"
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      Next
                    </button>
                  )}
                </div>
              )}
                        </div>
                      </>
                    )}
    </div>
  );
};

export default Myorders;